export default __webpack_public_path__ + "static/media/Chestplate of the Black Pharaoh.5aedbeb8.jpg";